import React, { useEffect, useState } from "react";
import Icon from "../../../assets/Icon";
import { Button, Card, Rate } from "antd";
import "../../../styles/overallAnalysis.css";
import overAllChart from "../../../assets/images/overallImage/overallChartImg.svg";
import overAllNiddle from "../../../assets/images/overallImage/overAllNiddle.svg";
import Utils from "../../utils/Utils";
import OverallModal from "./modals/OverallModal";

function TwoWayOverallAnalys({
  overallAnalysisData,
  skillAnalysisDataObj,
  switchSystem,
  interviewId,
  auth,
  interviewType,
  getReport,
  onSkillClick,
}) {
  const [needleValue, setNeedleValue] = useState(0);
  const maxRotation = 180; // Maximum rotation in degrees for the needle (0-180 degrees for half-circle gauge)
  const rotation = (needleValue / 100) * maxRotation - 90;

  const [overallModal, setOverallModal] = useState(false);

  const overallAnalysisDataObj = {
    positiveRemarks: switchSystem
      ? overallAnalysisData?.positiveRemarks
      : overallAnalysisData?.editedPositiveRemarks,
    negativeRemarks: switchSystem
      ? overallAnalysisData?.negativeRemarks
      : overallAnalysisData?.editedNegativeRemarks,
    verdict: switchSystem
      ? overallAnalysisData?.verdict
      : overallAnalysisData?.editedVerdict || "",
    summary: switchSystem
      ? overallAnalysisData?.summary
      : overallAnalysisData?.editedSummary || "",
  };

  const skillAnalysisData = skillAnalysisDataObj?.map((skill) => ({
    score: switchSystem ? skill.score : skill.editedScore,
    skill: skill.skill,
    negativeRemarks: switchSystem
      ? skill.negativeRemarks
      : skill.editedNegativeRemarks,
    positiveRemarks: switchSystem
      ? skill.positiveRemarks
      : skill.editedPositiveRemarks,
    skillWeightage: skill.skillWeightage,
    candidateInterviewSkillId: skill.candidateInterviewSkillId,
  }));

  const calculateAvg = () => {
    let weightedTotal = 0;
    let weightSum = 0;

    if (skillAnalysisData?.length > 0) {
      for (let i = 0; i < skillAnalysisData.length; i++) {
        let { score, skillWeightage } = skillAnalysisData[i];
        if (score < 0) {
          score = 0;
        }
        if (skillWeightage !== 0) {
          weightedTotal += score * skillWeightage;
        } else {
          weightedTotal += score;
        }

        weightSum += skillWeightage;
      }
      return weightSum > 0
        ? (weightedTotal / weightSum).toFixed(2)
        : (weightedTotal / skillAnalysisData?.length).toFixed(2);
    }
    return 0;
  };

  useEffect(() => {
    // let total = 0;
    let avg = 0;

    let weightedTotal = 0;
    let weightSum = 0;

    if (skillAnalysisData?.length > 0) {
      for (let i = 0; i < skillAnalysisData.length; i++) {
        // total += skillAnalysisData[i].score;

        let { score, skillWeightage } = skillAnalysisData[i];
        if (score < 0) {
          score = 0;
        }
        if (skillWeightage !== 0) {
          weightedTotal += score * skillWeightage;
        } else {
          weightedTotal += score;
        }
        weightSum += skillWeightage;
      }
      // avg = total / skillAnalysisData?.length;

      avg =
        weightSum > 0
          ? (weightedTotal / weightSum).toFixed(2)
          : (weightedTotal / skillAnalysisData?.length).toFixed(2);

      setNeedleValue(avg * 20);
    } else {
      setNeedleValue(0);
    }
  }, [skillAnalysisData]);

  return (
    <>
      {overallModal && (
        <OverallModal
          overallModal={overallModal}
          setOverallModal={setOverallModal}
          overallModalData={overallAnalysisData}
          interviewType={interviewType}
          auth={auth}
          interviewId={interviewId}
          getReport={getReport}
        />
      )}
      <div className="mt-7">
        <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
          <p className="bg-[#206DC5] border inline-block p-3 rounded-xl">
            <Icon type="overAll-analysis-icon" width="18" height="19" />
          </p>
          <span>
            Overall Analysis -{" "}
            <span className="text-[#206DC5]">{calculateAvg()}/5</span>
          </span>
        </div>

        <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]">
          <div className="overall-desktop items-center">
            <div className="print:w-[60%] w-[40%] lg:w-[60%] flex flex-col gap-[.5rem] justify-start items-start px-5">
              {skillAnalysisData?.map((item, i) => (
                <div
                  key={i}
                  className="border-2 avoid-break print:w-[85%] border-[#6eaff9] hover:scale-[1.03] duration-[250ms] transition-all cursor-pointer rounded-md px-[.4rem] py-[.35rem] flex print-skills-section flex-col lg:flex-row justify-between lg:w-[80%] xl:w-[85%] w-full lg:items-center items-start text-[0.94rem] text-[#475467] font-medium gap-1 "
                  onClick={() => onSkillClick(item.candidateInterviewSkillId)}
                >
                  <p className="w-full text-[1.04rem] leading-[1.28rem] ">
                    {Utils.toTitleCase(item?.skill)}
                  </p>
                  {item.score < 0 ? (
                    <div className="italic text-gray-500 font-normal text-[.92rem] min-w-[140px] max-w-[250px]">
                      Skill Not Assessed
                    </div>
                  ) : (
                    <Rate
                      className="custom-rate min-w-[140px] max-w-[250px]"
                      allowHalf
                      value={item.score}
                      disabled
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="print:w-[40%] w-[60%] lg:w-[40%] flex items-center justify-center relative">
              {/* First Image (Gauge) */}
              <img
                src={overAllChart}
                className="min-w-[300px] max-w-[400px]"
                alt="Gauge"
              />

              {/* Second Image (Needle) */}
              <img
                src={overAllNiddle}
                width={12}
                height={12}
                alt="Needle"
                className="absolute" // Position it absolutely relative to the container
                style={{
                  top: "98%", // Center vertically
                  left: "50%", // Center horizontally
                  transform: `translate(-50%, -100%) rotate(${rotation}deg)`, // Rotate based on value
                  transformOrigin: "bottom center",
                }}
              />
            </div>
          </div>
          <div className="overall-mobile  items-center w-full">
            <div className="w-full flex items-center justify-center ">
              {/* <OverallChart /> */}
              <img src={overAllChart} width={230} height={230} alt="Gauge" />

              {/* Second Image (Needle) */}
              <img
                src={overAllNiddle}
                width={10}
                height={10}
                alt="Needle"
                className="absolute" // Position it absolutely relative to the container
                style={{
                  top: "138px", // Center vertically
                  left: "50%", // Center horizontally
                  // bottom:5,
                  transform: `translate(-50%, -100%) rotate(${rotation}deg)`, // Rotate based on value
                  transformOrigin: "bottom center",
                }}
              />
            </div>

            <div className=" w-full mt-7 min-[400px]:text-start text-center">
              {skillAnalysisData?.map((item, i) => (
                <div className="text-[#475467] border-2 border-[#6eaff9] rounded-md px-1 py-0 mb-2 font-semibold min-[400px]:flex justify-between items-center mt-1">
                  <p className="min-[400px]:w-[200px] w-full text-[1rem]">
                    {Utils.toTitleCase(item?.skill)}
                  </p>
                  {item.score < 0 ? (
                    <div className="italic text-gray-500 font-normal text-[.9rem] min-w-[140px] max-w-[250px]">
                      Skill Not Assessed
                    </div>
                  ) : (
                    <Rate
                      className="custom-rate"
                      allowHalf
                      value={item.score}
                      disabled
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="mt-4">
            {switchSystem !== true && (
              <p className="flex justify-end mb-[-.5rem] items-end">
                {overallAnalysisData?.edited && <p>Edited*</p>}
                <Button
                  type="link"
                  onClick={() => {
                    setOverallModal(true);
                  }}
                  className=""
                  size="small"
                >
                  <Icon type="skill-edit-modal-icon" width="16" height="16" />
                </Button>
              </p>
            )}
            <div className="mt-4 flex flex-col print:flex-row md:flex-row w-full items-center gap-x-4 gap-y-3 print:items-stretch">
              <Card className="print:w-[60%] bg-white md:w-[60%] w-full print:h-auto">
                <div className="print:h-full h-[15rem] scroll overflow-y-auto px-2">
                  <div className="font-semibold text-lg">Strength</div>
                  <ul
                    className="mt-[.2rem] text-[#475467]"
                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                  >
                    {overallAnalysisDataObj?.positiveRemarks?.map((data, i) => (
                      <li key={i} className="my-[.12rem] avoid-break">
                        {data}
                      </li>
                    ))}
                  </ul>

                  <p className="font-semibold text-lg mt-[.8rem]">Weakness</p>
                  <ul
                    className="mt-[.2rem] text-[#475467]"
                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                  >
                    {overallAnalysisDataObj?.negativeRemarks?.map((data, i) => (
                      <li key={i} className="my-[.12rem] avoid-break">
                        {data}
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>

              <Card className="print:w-[40%] bg-white md:w-[40%] w-full print:h-auto flex flex-col border">
                <div className="flex-1 flex flex-col justify-center items-center text-center print:h-full">
                  <p className="font-semibold text-xl">Summary</p>
                  <p className="text-[#475467] pt-[.5rem] px-2 print:h-full print:max-h-none max-h-[13rem] scroll overflow-y-auto text-[.92rem] leading-[1.36rem]">
                    {overallAnalysisDataObj.summary || "N/A"}
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}

export default TwoWayOverallAnalys;
